import * as actionTypes from 'login-actions/actionTypes';

export default (
  state: LayoutState = {
    title: null,
    footer: null,
  },
  action: FluxStandardAction<any, any>,
): LayoutState => {
  switch (action.type) {
    case actionTypes.SET_APP_TITLE:
      return { ...state, title: action.payload };
    case actionTypes.SET_APP_FOOTER:
      return { ...state, footer: action.payload };
    default:
      return state;
  }
};
